
  document.addEventListener('DOMContentLoaded', function () {

    const subscriptionOptions =
      document.querySelectorAll('input[name="subscription"]');

    const autoRefillCheckbox =
      document.getElementById('auto_refill');

    const sellingPlanInput =
      document.getElementById('selling_plan_input');

    const quantityInput =
      document.getElementById('quantity_input');


    const originalTotalPriceDisplay =
      document.getElementById('original_total_price');

    const discountedTotalPriceDisplay =
      document.getElementById('discounted-total-price');

    const savingsPercentageDisplay =
      document.getElementById('savings-percentage');


    const originalTotalPriceDisplay1 =
      document.getElementById('original-total-price1');

    const discountedTotalPriceDisplay1 =
      document.getElementById('discounted-total-price1');

    const savingsPercentageDisplay1 =
      document.getElementById('savings-percentage1');


    const sellingPlanOptions =
      document.querySelectorAll('select option');


    const variantConfig = [
      {
        delay: 'Auto-delivers every 28 days',
        refillText: 'refill ships every month'
      },
      {
        delay: 'Auto-delivers every 56 days',
        refillText: 'refill ships every 2 months'
      },
      {
        delay: 'Auto-delivers every 84 days',
        refillText: 'refill ships every 3 months'
      }
    ];


    function getSellingPlanForIndex(variantIndex) {

      if (!sellingPlanOptions.length) {
        return '';
      }

      if (sellingPlanOptions.length === 1) {
        return sellingPlanOptions[0].value;
      }

      if (sellingPlanOptions[variantIndex]) {
        return sellingPlanOptions[variantIndex].value;
      }

      return sellingPlanOptions[0].value;
    }


    function getSellingPlanOption(variantIndex) {

      if (sellingPlanOptions.length === 1) {
        return sellingPlanOptions[0];
      }

      if (sellingPlanOptions[variantIndex]) {
        return sellingPlanOptions[variantIndex];
      }

      return sellingPlanOptions[0];
    }


    function getSubscriptionPrice(basePrice, variantIndex) {

      const planOption =
        getSellingPlanOption(variantIndex);

      if (!planOption) {
        return basePrice;
      }


      const adjustmentType =
        planOption.dataset.adjustmentType;

      const adjustmentValue =
        parseFloat(planOption.dataset.id);


      if (isNaN(adjustmentValue)) {
        return basePrice;
      }


      if (adjustmentType === "price") {

        return adjustmentValue / 100;

      } else if (adjustmentType === "percentage") {

        return basePrice * (1 - adjustmentValue / 100);

      } else if (adjustmentType === "fixed_amount") {

        return basePrice - (adjustmentValue / 100);

      }


      return basePrice;
    }


    /*
     * Refill price:
     *
     * Second price adjustment থাকলে
     * second price use করবে.
     *
     * Second price না থাকলে
     * first/default subscription
     * price use করবে.
     */
    function getRefillPrice(basePrice, variantIndex) {

      const planOption =
        getSellingPlanOption(variantIndex);


      if (!planOption) {

        return getSubscriptionPrice(
          basePrice,
          variantIndex
        );

      }


      const secondAdjustmentType =
        planOption.dataset.secondAdjustmentType;


      const secondAdjustmentValue =
        parseFloat(
          planOption.dataset.secondId
        );


      const hasSecondAdjustment =
        secondAdjustmentType &&
        !isNaN(secondAdjustmentValue);


      if (!hasSecondAdjustment) {

        return getSubscriptionPrice(
          basePrice,
          variantIndex
        );

      }


      if (secondAdjustmentType === "price") {

        return secondAdjustmentValue / 100;

      }


      if (secondAdjustmentType === "percentage") {

        return basePrice *
          (1 - secondAdjustmentValue / 100);

      }


      if (secondAdjustmentType === "fixed_amount") {

        return basePrice -
          (secondAdjustmentValue / 100);

      }


      return getSubscriptionPrice(
        basePrice,
        variantIndex
      );
    }


    function getCurrencySymbol() {

      const dummyText =
        document.getElementById('dummy-price')
          ?.textContent || '$1.00';


      const symbol =
        dummyText
          .replace(/[0-9.,\s]/g, '')
          .trim();


      return symbol || '$';
    }


    function formatPrice(price) {

      return getCurrencySymbol() +
        parseFloat(price).toFixed(2);

    }


    /*
     * SHIPPING GUARD
     *
     * Metafield missing  -> no shipping
     * Metafield blank    -> no shipping
     * Value <= 0         -> no shipping
     * Invalid value      -> no shipping
     * Positive value     -> show shipping
     */
    function getRefillShippingPrice() {

      const shippingPriceElement =
        document.getElementById(
          'refill-shipping-price'
        );


      if (!shippingPriceElement) {
        return '';
      }


      const shippingCents =
        parseFloat(
          shippingPriceElement.dataset.cents
        );


      if (
        !Number.isFinite(shippingCents) ||
        shippingCents <= 0
      ) {
        return '';
      }


      const formattedShippingPrice =
        shippingPriceElement
          .textContent
          .trim();


      if (!formattedShippingPrice) {
        return '';
      }


      return formattedShippingPrice;
    }


    function calculatePercentageSaved(
      original,
      discounted
    ) {

      if (!original || !discounted) {
        return '';
      }


      const savings =
        (original - discounted) /
        original *
        100;


      return 'SAVE ' +
        Math.floor(savings) +
        '%';
    }


    function calculateDollarSavings(
      original,
      discounted
    ) {

      const symbol =
        getCurrencySymbol();


      const savings =
        original - discounted;


      return 'Save ' +
        symbol +
        savings.toFixed(2);
    }


    function getBaselinePrice(option, basePrice, finalPrice) {
    if (finalPrice < basePrice) return basePrice;
    var compare = parseFloat(option.dataset.compare);
    return (Number.isFinite(compare) && compare > finalPrice) ? compare : null;
  }

  function updatePricesForAllOptions() {

      subscriptionOptions.forEach(
        function (option, variantIndex) {

          let basePrice =
            parseFloat(
              option.dataset.price
            );


          if (isNaN(basePrice)) {
            basePrice = 0;
          }


          let finalPrice =
            basePrice;


          const priceInfo =
            option
              .closest(
                '.variants-bundles__option'
              )
              .querySelector(
                '.price-info'
              );


          const currentPriceElement =
            priceInfo.querySelector(
              '.current-prcie'
            );


          const comparePriceElement =
            priceInfo.querySelector(
              '.compare-prcie'
            );


          const saveElement =
            option
              .closest(
                '.variants-bundles__option'
              )
              .querySelector(
                '.save'
              );


          currentPriceElement.textContent =
            formatPrice(finalPrice);


          var baseline = getBaselinePrice(option, basePrice, finalPrice);

          if (baseline) {

            comparePriceElement.textContent =
              formatPrice(baseline);


            saveElement.textContent =
              calculateDollarSavings(
                baseline,
                finalPrice
              );


            saveElement.style.display =
              'inline-flex';

          } else {

            comparePriceElement.textContent =
              '';


            saveElement.textContent =
              '';


            saveElement.style.display =
              'none';

          }


          option.dataset.finalPrice =
            finalPrice;

        }
      );

    }


    function updateTotalPrice() {

      const selectedOption =
        document.querySelector(
          'input[name="subscription"]:checked'
        );


      if (!selectedOption) {
        return;
      }


      const variantIndex =
        Array.from(
          subscriptionOptions
        ).indexOf(
          selectedOption
        );


      const basePrice =
        parseFloat(
          selectedOption.dataset.price
        );


      const finalPrice =
        basePrice;


      if (autoRefillCheckbox.checked) {

        if (originalTotalPriceDisplay) {

          originalTotalPriceDisplay.textContent =
            formatPrice(basePrice);

        }


        if (discountedTotalPriceDisplay) {

          discountedTotalPriceDisplay.textContent =
            formatPrice(finalPrice);

        }


        if (savingsPercentageDisplay) {

          savingsPercentageDisplay.textContent =
            calculatePercentageSaved(
              basePrice,
              finalPrice
            );


          savingsPercentageDisplay.style.display =
            'inline-flex';

        }


        if (originalTotalPriceDisplay1) {

          originalTotalPriceDisplay1.textContent =
            `Value: ${formatPrice(basePrice)}`;

        }


        if (discountedTotalPriceDisplay1) {

          discountedTotalPriceDisplay1.textContent =
            `You pay: ${formatPrice(finalPrice)}`;

        }


        if (savingsPercentageDisplay1) {

          savingsPercentageDisplay1.textContent =
            calculateDollarSavings(
              basePrice,
              finalPrice
            );


          savingsPercentageDisplay1.style.display =
            'inline-flex';

        }

      } else {

        if (originalTotalPriceDisplay) {

          originalTotalPriceDisplay.textContent =
            '';

        }


        if (discountedTotalPriceDisplay) {

          discountedTotalPriceDisplay.textContent =
            formatPrice(finalPrice);

        }


        if (savingsPercentageDisplay) {

          savingsPercentageDisplay.textContent =
            '';


          savingsPercentageDisplay.style.display =
            'none';

        }


        if (originalTotalPriceDisplay1) {

          originalTotalPriceDisplay1.textContent =
            '';

        }


        if (discountedTotalPriceDisplay1) {

          discountedTotalPriceDisplay1.textContent =
            `You pay: ${finalPrice}`;

        }


        if (savingsPercentageDisplay1) {

          savingsPercentageDisplay1.textContent =
            '';


          savingsPercentageDisplay1.style.display =
            'none';

        }

      }

    }


    function updateShippingInfo() {

      const selectedOption =
        document.querySelector(
          'input[name="subscription"]:checked'
        );


      if (!selectedOption) {
        return;
      }


      const variantIndex =
        Array.from(
          subscriptionOptions
        ).indexOf(
          selectedOption
        );


      const config =
        variantConfig[
          variantIndex
        ];


      if (!config) {
        return;
      }


      const basePrice =
        parseFloat(
          selectedOption.dataset.price
        );


      /*
       * Refill price:
       * second adjustment first,
       * then first subscription price fallback.
       */
      const refillPrice =
        getRefillPrice(
          basePrice,
          variantIndex
        );


      /*
       * Shipping price:
       * only returned when valid
       * positive metafield value exists.
       */
      const shippingPrice =
        getRefillShippingPrice();


      const delaySpan =
        document.querySelector(
          '.sub_shipping_delay span'
        );


      const detailsSpan =
        document.querySelector(
          '.sub_shipping_details span'
        );


      if (delaySpan) {

        delaySpan.textContent =
          config.delay;

      }


      if (detailsSpan) {

        /*
         * Metafield has valid shipping value:
         *
         * $54.99 + $4.95 shipping -
         * refill ships every 2 months
         */
        if (shippingPrice) {

          detailsSpan.innerHTML =
            `<em>${formatPrice(refillPrice)}</em> + ${shippingPrice} shipping - ${config.refillText}`;

        }

        /*
         * No metafield / blank / zero:
         *
         * $54.99 - refill ships every 2 months
         */
        else {

          detailsSpan.innerHTML =
            `<em>${formatPrice(refillPrice)}</em> - ${config.refillText}`;

        }

      }

    }


    function updateInputs(
      skipVariantTrigger = false
    ) {

      const selectedOption =
        document.querySelector(
          'input[name="subscription"]:checked'
        );


      if (!selectedOption) {
        return;
      }


      const variantIndex =
        Array.from(
          subscriptionOptions
        ).indexOf(
          selectedOption
        );


      const quantity =
        selectedOption.dataset.quantity;


      quantityInput.value =
        quantity;


      var planId = autoRefillCheckbox.checked
        ? getSellingPlanForIndex(variantIndex)
        : '';

        sellingPlanInput.value = planId;

      sellingPlanInput.disabled = !planId;

        


      if (!skipVariantTrigger) {

        const variantTrigger =
          document.querySelector(
            `#variant_wrapper input[value="${selectedOption.value}"]`
          );


        if (variantTrigger) {
          variantTrigger.click();
        }

      }


      updatePricesForAllOptions();

      updateTotalPrice();

      updateShippingInfo();

    }


    subscriptionOptions.forEach(
      option => {

        option.addEventListener(
          'change',
          () => {

            updateInputs();

          }
        );

      }
    );


    autoRefillCheckbox.addEventListener(
      'change',
      updateInputs
    );


    let byOnce =
      document.querySelector(
        ".byOnce"
      );


    let bySubs =
      document.querySelector(
        ".bySubs"
      );


    let bySubsBox =
      document.querySelector(
        ".bySubsBox"
      );


    bySubs.style.display =
      "none";


    byOnce.addEventListener(
      "click",
      () => {

        autoRefillCheckbox.click();

        byOnce.style.display =
          "none";

        bySubsBox.style.display =
          "none";

        bySubs.style.display =
          "block";

      }
    );


    bySubs.addEventListener(
      "click",
      () => {

        autoRefillCheckbox.click();

        byOnce.style.display =
          "block";

        bySubsBox.style.display =
          "block";

        bySubs.style.display =
          "none";

      }
    );


    updateInputs(true);

  });
